var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.iframesHeight)},[_c('iframe',{attrs:{"frameborder":"0","src":"https://lbs.qq.com/getPoint/","height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }